import { render, staticRenderFns } from "./WallboxDetailsItem.vue?vue&type=template&id=15513fb1"
import script from "./WallboxDetailsItem.vue?vue&type=script&lang=js"
export * from "./WallboxDetailsItem.vue?vue&type=script&lang=js"
import style0 from "./WallboxDetailsItem.vue?vue&type=style&index=0&id=15513fb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports